module.exports = __webpack_public_path__ + "static/img/photo-chen.324aa78.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/photo-chen.png
// module id = GePm
// module chunks = 0